import _ from 'lodash'
import * as retailerUtils from '../utils/retailer'
import { MB } from './file'
import { isPasswordStrong } from './passwordRules'

function isNullOption(option) {
  return option == null || option === '' || option === '-'
}

const numericFieldLabels = {
  markup: 'Markup',
  salePrice: 'Sale Price',
  totalWeightCarat: 'Total Weight (carat)',
  mountSize: 'Mount Size',
  totalWeightGrams: 'Total Weight (grams)'
}

export function validateLogin(data) {
  let valid = true
  const error = {}
  if (!data.email) {
    error.email = 'Email is required'
    valid = false
  }
  if (!data.password) {
    error.password = 'Password is required'
    valid = false
  }
  return { valid, error }
}

export function validateRegister(data) {
  let valid = true
  const error = {}
  if (!data.email) {
    error.email = 'Email is required'
    valid = false
  } else if (!validateEmail(data.email)) {
    error.email = 'Invalid email'
    valid = false
  }
  if (!data.email) {
    error.email = 'Email is required'
    valid = false
  } else if (!validateEmail(data.email)) {
    error.email = 'Invalid email'
    valid = false
  }
  if (!data.password) {
    error.password = 'Password is required'
    valid = false
  }
  if (!data.name) {
    error.name = 'Seller Name / Store Name is required'
    valid = false
  }
  if (!data.storeAddress) {
    error.location = 'Location is required'
    valid = false
  }
  return { valid, error }
}

export function validateDiamond(data, images) {
  let valid = true
  const error = {}
  if (!data.retailerId) {
    error.retailer = 'Inventory must be attached to a retailer'
    valid = false
  }
  if (!data.title || !String(data.title).trim()) {
    error.title = 'Title is required'
    valid = false
  }
  if (data.saleMarkupType === 'sale') {
    if (data.price < data.salePrice) {
      error.salePrice = 'Sale Price must be less than the retail price'
      valid = false
    } else if (!data.salePrice) {
      error.salePrice = 'Please provide a Sale Price'
      valid = false
    }
  }
  if (data.saleMarkupType === 'markup') {
    if (!data.markup) {
      error.markup = 'Please provide a markup'
      valid = false
    }
  }
  ;['price', 'carat'].forEach(field => {
    if (!_.isNumber(data[field])) {
      error[field] = `Invalid ${field}`
      valid = false
    }
    if (!data[field]) {
      error[field] = `${_.capitalize(field)} is required`
      valid = false
    }
  })
  ;['shape', 'cut', 'clarity', 'color', 'certificate'].forEach(field => {
    if (isNullOption(data[field])) {
      error[field] = `${_.capitalize(field)} is required`
      valid = false
    }
  })
  ;['propLength', 'propWidth', 'propDepth'].forEach(field => {
    if (data[field] === 0 || (data[field] && !_.isNumber(data[field]))) {
      error['proportions'] = 'Invalid proportions'
      valid = false
    }
  })
  if (data.colorType === 'fancy') {
    if (!data.intensity) {
      error.intensity = 'Intensity is required'
      valid = false
    }
  }
  ;[
    'markup',
    'salePrice',
    'totalWeightCarat',
    'mountSize',
    'totalWeightGrams'
  ].forEach(field => {
    if (!isNullOption(data[field]) && !_.isNumber(data[field])) {
      const label = numericFieldLabels[field] || field
      error[field] = `${label}: please enter a valid number`
      valid = false
    }
  })
  if (data.setting === 'non-diamond-jewelry' || data.setting === 'gemstone') {
    if (!data.gemstone) {
      error.gemstone = 'Gemstone is required'
      valid = false
    }
  }
  const hasUploadedFile = images && images.some(img => img.file)
  const hasExistingUrl = images && images.some(
    img => !img.file && img.attributes && img.attributes.url
  )
  if (!hasUploadedFile && !hasExistingUrl && !data.firstImagePath) {
    error.images = 'Please attach at least one image to your item'
    valid = false
  }
  if (images && images.length > 0) {
    images.forEach(({ file }) => {
      if (file && file.size > 10 * MB) {
        error.images = 'Image files cannot be larger than 10 MB'
        valid = false
      }
    })
  }
  return { valid, error }
}

export function validateRetailer(data) {
  let valid = true
  const error = {}
  if (!data.email) {
    error.email = 'Email is required'
    valid = false
  } else if (!validateEmail(data.email)) {
    error.email = 'Invalid email'
    valid = false
  }
  if (!data.name) {
    error.name = 'Store name is required'
    valid = false
  }
  if (!data.storeAddress) {
    error.storeAddress = 'Store address is required'
    valid = false
  }
  if (!data.countryCode) {
    error.countryCode = 'Country code is required'
    valid = false
  }
  if (!data.phone) {
    error.phone = 'Phone number is required'
    valid = false
  } else if (!validatePhone(data.phone)) {
    error.phone = 'Invalid phone number'
    valid = false
  }
  if (data.statusCode === retailerUtils.statusCodes.PRIVATE.value) {
    if (!data.privatePassword) {
      error.privatePassword = 'Access code is required'
      valid = false
    }
  }
  return { valid, error }
}

export function validateNewAccount(data) {
  let valid = true
  const error = {}
  if (!data.username) {
    error.username = 'Username is required'
    valid = false
  }
  if (data.password !== data.verifyPassword) {
    error.password = error.verifyPassword = "Password doesn't match"
    valid = false
  }
  if (!data.password) {
    error.password = 'Password is required'
    valid = false
  }
  if (!data.verifyPassword) {
    error.verifyPassword = 'Confirm password is required'
    valid = false
  }
  return { valid, error }
}

export function validateEmail(data) {
  const re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
  return re.test(data)
}

export function validateForgotPassword(data) {
  let valid = true
  const error = {}
  if (!data.email) {
    error.email = 'Email is required'
    valid = false
  } else if (!validateEmail(data.email)) {
    error.email = 'Please enter a valid email address'
    valid = false
  }
  return { valid, error }
}

export function validateResetPassword(data) {
  let valid = true
  const error = {}
  if (!data.password) {
    error.password = 'New password is required'
    valid = false
  } else if (!isPasswordStrong(data.password)) {
    error.password = 'Password does not meet all the requirements below'
    valid = false
  }
  if (!data.confirmPassword) {
    error.confirmPassword = 'Please confirm your new password'
    valid = false
  } else if (data.password && data.password !== data.confirmPassword) {
    error.confirmPassword = 'Passwords do not match'
    valid = false
  }
  return { valid, error }
}

export function validatePassword(data, withOldPassword) {
  let valid = true
  const error = {}
  if (withOldPassword) {
    // Account Settings: all password fields are required
    if (!data.oldPassword) {
      error.oldPassword = 'Old password is required'
      valid = false
    }
    if (!data.password) {
      error.password = 'New password is required'
      valid = false
    } else if (!isPasswordStrong(data.password)) {
      error.password = 'Password does not meet all the requirements below'
      valid = false
    }
    if (!data.verifyPassword) {
      error.verifyPassword = 'Confirm password is required'
      valid = false
    } else if (data.password && data.password !== data.verifyPassword) {
      error.verifyPassword = 'Passwords do not match'
      valid = false
    }
  } else {
    if (data.password || data.verifyPassword) {
      if (!data.password) {
        error.password = 'Password is required'
        valid = false
      } else if (!isPasswordStrong(data.password)) {
        error.password = 'Password does not meet all the requirements below'
        valid = false
      }
      if (!data.verifyPassword) {
        error.verifyPassword = 'Confirm password is required'
        valid = false
      } else if (data.password && data.password !== data.verifyPassword) {
        error.verifyPassword = "Passwords do not match"
        valid = false
      }
    }
  }
  return { valid, error }
}

export function validatePhone(phone) {
  const cleaned = phone.replace(/\D/g, '')
  if (cleaned.length < 10 || cleaned.length > 15) {
    return false
  }
  const phoneRegex =  /^\+?[1-9]\d{1,14}$/
  return phoneRegex.test(cleaned)
}

export default {
  login: validateLogin,
  register: validateRegister,
  diamond: validateDiamond,
  retailer: validateRetailer,
  newAccount: validateNewAccount,
  password: validatePassword
}
